<app-layout-main [pageMetadata]="{ title: originalAppName() }" [layoutSize]="'small'" [design]="'clean'">
	<lib-card [title]="'Cookie policy'">
		<div>
			<p>
				This is the Cookie Policy for Gymvio, accessible from
				<a href="https://gymvio.com">https://gymvio.com</a> and all subdomains
			</p>

			<p><strong>What Are Cookies</strong></p>

			<p>
				To make gymvio.com and its subdomains work properly, we sometimes place small data files called cookies
				on your device. Most big websites do this too. A cookie is a small text file that a website saves on
				your computer or mobile device when you visit the site, respond to surveys, or participate in polls. It
				enables our website to remember your actions and preferences (such as login, language, font size, and
				other display preferences) over a period of time, so you don't have to keep re-entering them whenever
				you come back to the site or browse from one page to another.
			</p>

			<p>
				If you want to know more about cookies, head to
				<a href="http://aboutcookies.org">aboutcookies.org</a> or
				<a href="http://allaboutcookies.org">allaboutcookies.org</a>.
			</p>

			<p><strong>How We Use Cookies</strong></p>

			<p>
				We use cookies for a variety of reasons detailed below. Unfortunately in most cases there are no
				industry standard options for disabling cookies without completely disabling the functionality and
				features they add to this site. It is recommended that you leave on all cookies if you are not sure
				whether you need them or not in case they are used to provide a service that you use.
			</p>

			<p><strong>The Cookies We Set</strong></p>

			<ul>
				<li>
					<p>Account related cookies</p>
					<p>
						If you create an account with us then we will use cookies for the management of the signup
						process and general administration. These cookies will usually be deleted when you log out
						however in some cases they may remain afterwards to remember your site preferences when logged
						out.
					</p>
				</li>

				<li>
					<p>Login related cookies</p>
					<p>
						We use cookies when you are logged in so that we can remember this fact. This prevents you from
						having to log in every single time you visit a new page. These cookies are typically removed or
						cleared when you log out to ensure that you can only access restricted features and areas when
						logged in.
					</p>
				</li>

				<li>
					<p>Site preferences cookies</p>
					<p>
						In order to provide you with a great experience on this site we provide the functionality to set
						your preferences for how this site runs when you use it. In order to remember your preferences
						we need to set cookies so that this information can be called whenever you interact with a page
						is affected by your preferences.
					</p>
				</li>
			</ul>

			<p><strong>Third Party Cookies</strong></p>

			<p>
				Third-party cookies originate from a domain that's different to the website being visited. We don't
				control how they use their cookies, so we suggest you check their website to see how they're using them
				and how you can manage them.
			</p>

			<ul>
				<li>
					<p>
						We use Paddle as our Merchant of record - all payments are handled by Paddle. To ensure that
						payment works correctly, Paddle requires that certain cookies are stored. For more information
						about Paddle see <a href="https://paddle.com">https://paddle.com</a> &
						<a href="https://paddle.com/privacy">https://paddle.com/privacy</a>
					</p>
				</li>
			</ul>

			<p><strong>Controlling your cookies</strong></p>

			<p>
				You can control cookies in your browser, to enable or disable them. If you wish to restrict or block the
				cookies which are set by any website – including Kentico.com website and its subdomains – you should do
				this through the web browser settings for each web browser you use, on each device you use to access the
				internet. Information on controlling and deleting cookies, including on a wide variety of browsers, is
				also available at allaboutcookies.org.
			</p>

			<p>
				If you choose not to enable cookies, you'll still be able to browse our website, but it will restrict
				some of the functionality of our website or what you can do.
			</p>

			<p>
				If you are still looking for more information then you can contact us through one of our preferred
				contact methods:
			</p>

			<ul>
				<li>Email: info[at]gymvio.com</li>
			</ul>
		</div>
	</lib-card></app-layout-main
>
